import { useEffect } from 'react';
import { useAppSelector } from '@/app/store';

export const useTgCloseModal = () => {
  const productsCount = useAppSelector((state) => state.basket.numberOfProducts);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg) return;

    const version = parseFloat(tg.version);
    if (version < 6.2) return;

    if (productsCount === 0) tg.disableClosingConfirmation();
    else tg.enableClosingConfirmation();
  }, [productsCount]);
};
